import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import { SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { createPages, currentDateAndTime, decodeData } from "../../Constants/constants";
import { constructNow } from "date-fns";
import TooltipComponent from "../../Components/TooltipComponent";

class SendBulkLetters extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      company_location_shift_id: 0,
      leave_type_ids: "",
      effective_date: null,
      location_shift_id: "",
      grade_id: "",
      designation_id: "",
      location_id: "",
      department_id: "",
      category_id: "",
      state_id:"",
      employee_type_id:"",
      attendance_capture_mode:"All",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      assignLeaveModal: false,
      Shift_rows: [],
      capturemode_options: '',
      location_options: [],
      department_options: [],
      designation_options: [],
      grade_options: [],
      state_options: [],
      category_options: [],
      type_options: [],
      location_row: [],
      company_location_shift_row: [],
      days_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      loadingFilter: false,
      loadingSearch: false,
      decodedData: [],
      emailOptions: [],
      lettersOptions: [],
      signatoryRows: [],
      selectedEmail: false,
      selectedLetter: false,
      shareCtc: false,
      shareSalary: false,
      assignedAttendanceCaptureMode: "",
      assignedModal: false,
      mail_body: false,
      mail_subject: false,
      selectedSignatoryTemplate: false,
      company_letter_title: false,
      company_letter_content: false,
      markings: false,
      letterhead_url: false,
      assigned_attendance_status:"All",
      responseModal:false, 
      responseList:[],
      DataCaptures:[
        {value:'All', label:"All"},
        { value: "1", label: 'Mobile With Geo Tagging' },
        { value: "2", label: 'Mobile Without Geo Tagging' },
        { value: "3", label: 'Web With Geo Tagging' },
        { value: "4", label: 'Web Without Geo Tagging' },
        { value: "5", label: 'Biometric Attendance' },      
      ],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetShiftList();
    //   this.GetLocationList();
    //   this.GetDepartmentMasters();
    this.getEmailList();
    this.getLetterList();
    this.getSignatoryTemplateList();
    this.getAllEmployeesOptionList();
    this.GetLeavesMasters();
    this.GetEmploymentMasterList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("this.state.assigned_leave_status",this.state.assigned_leave_status);
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetList =  () => {
    const { apiURL, apiHeaderJSON } = this.context; 
    const headers = apiHeaderJSON;
    
    // Axios GET request
    axios
      .get(`${apiURL}Employees/AppointmentLetterSendEmployeeList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          grade_id: this.state.grade_id || "",
          designation_id: this.state.designation_id || "",
          location_id: this.state.location_id || "",
          department_id: this.state.department_id || "",
          category_id: this.state.category_id || "",
          assigned_attendance_status: this.state.assigned_attendance_status==="All" ? null : this.state.assigned_attendance_status,
        },
        headers,
      })
      .then((response) => {
        // Check if the API call was successful
        if (response.data.success === true) {
          const data = response.data;
          console.log("GetAssignedCaptureMode data",data);
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
          });
        }
        this.setState({
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
      })
      .catch((error) => {
        // Handle API errors
        console.error("Error fetching data:", error);
        this.setState({
          loadingList: false,
          loadingSearch: false,
          loadingFilter: false,
        });
      });
  };

    getEmailList = () => {
    const { apiURL, apiHeaderJSON } = this.context; 
    const headers = apiHeaderJSON
    axios
        .get(`${apiURL}MailMaster/GetMailTemplateList`, {
        params: {
            limit: 999,
            page: 1,
            // keyword: filter?.keyword ,
            // checkHeadType: filter?.checkHeadType,
        },
        headers
        })
        .then(response => {
        const data = response.data
        console.log(response?.data)
        if (response.data.success === true) {
            const temp=data?.response?.data?.map((val)=>{
                return { value: val?.mail_template_id, label: val?.mail_template_title, mail_body: val?.mail_body, mail_subject: val?.mail_subject }
            })
            this.setState({emailOptions: temp});
        }
        })
        .catch(function (error) {
        console.log('error', error)
        })
    }

  getLetterList = () => {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      axios.get(`${apiURL}Masters/GetCompanyLettersList`, {
        params: { limit: 999, 
                page: 1, 
                },
          headers,
        })
        .then((response) => {
          var data = response.data;
          if (response.data.success === true) {
            const temp=data?.data?.map((val)=>{
                return ({ value: val?.company_letter_id, 
                  label: val?.company_letter_title, 
                  company_letter_content: val?.company_letter_content, 
                  markings: val?.markings, 
                  letterhead_url: val?.letterhead_url
                })
            })
            this.setState({
              lettersOptions: temp,
            });
          } else {
            this.setState({ loadingList: false,loadingSearch: false, });
          }
        }).catch((error) => {
          this.setState({ loadingList: false, loadingSearch: false});
        });
    };


  getAllEmployeesOptionList = (e) => {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}Masters/GetCompanyEmployeesList`, { params: { keyword: '' }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ allEmpOptions: response.data.data });
              console.log("GetCompanyEmployeesList =>",response.data.data);
            } else {
              this.setState({allEmpOptions:[]});
            }
          })
      } catch (error) {
        console.error("error", error)
      }
  }
    getSignatoryTemplateList = ()=>{
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      axios
        .get(`${apiURL}Masters/GetSignatures`, {
          params: { limit: 100, page: 1, keyword: null },
          headers,
        })
        .then((response) => {
          var data = response.data;
          console.log("GetSignatures",data);
          if (response.data.success === true) {
            const rows= data?.data?.map((val,idx)=>{
              return (
                {value: val?.signatory_id,
                    label:val?.signatory_identification_type,
                    url:val?.signatory_signature_file_url,
                  }
              )
            });
            console.log("GetSignatures rows",rows);
            this.setState({
              signatoryRows: rows,
            });
          } else {
            this.setState({ loadingList: false });
          }
        });
    }
  
  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const letter_content= createPages(this.state.company_letter_content,this.state.letterhead_url,this.state.markings)

    const formData = {
        employees_list: this.state.selectedRows,
        mail_template:[{
            mail_template_id: this.state.selectedEmail,
            mail_body: this.state.mail_body,
            mail_subject:this.state.mail_subject,
        }],
        letter_data:[{
            company_letter_id: this.state.selectedLetter,
            company_letter_title: this.state.company_letter_title,
            company_letter_content: this.state.company_letter_content,
            letter_rows: letter_content,
            letterhead_url:this.state.letterhead_url,
            markings: this.state.markings,
        }],
        signatory_id: this.state.selectedSignatoryTemplate,
        shareCtc: this.state.shareCtc || null,
        shareSalary: this.state.shareSalary || null,
        date: currentDateAndTime(),
    };
    console.log("form data ====>>>", formData);
    axios
      .post(`${apiURL}Employees/SendBulkAppointmentLetter`, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          if(Array.isArray(response.data?.error_response) && response.data?.error_response?.length>0){
            this.setState(
              {
                responseModal: true,
                responseList: response.data?.error_response,
                loadingList: true,
                assignedModal: false, 
                selectedEmail: false,
                selectedLetter: false,
                shareCtc: false,
                shareSalary: false,
                mail_subject: "", 
                selectedSignatoryTemplate: "", 
                company_letter_content: "", 
                company_letter_title: "", 
                markings: "", 
                letterhead_url: "", 
                mail_body: "", 
                selectedRows:[],
                postLoading: false,
              },
              (prevState) => {
                  this.GetList();
                  this.GetEmploymentMasterList();
              }
            );
          }
          else{
            Swal.fire({
              title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
              }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
              showConfirmButton: true,
              allowOutsideClick: false,
              });
              this.setState(
                {
                  responseModal: false,
                  responseList: [],
                  loadingList: true,
                  assignedModal:false, 
                  selectedEmail:false,
                  selectedLetter:false,
                  shareCtc:false,
                  shareSalary:false,
                  mail_subject: "", 
                  selectedSignatoryTemplate: "", 
                  company_letter_content: "", 
                  markings: "", 
                  letterhead_url: "", 
                  mail_body: "", 
                  selectedRows:[],
                  postLoading:false,
                },
                (prevState) => {
                    this.GetList();
                    this.GetEmploymentMasterList();
                }
              );
          }
         
        } else {
          this.setState({ loadingList: true, postLoading:false });
          Swal.fire({
            title: `<strong>${
                response.data.success === true ? "Success" : "Failed"
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton: true,
            allowOutsideClick: false,
            });
        }
        
      })
      .catch((error)=>{
        this.setState({ loadingList: true, postLoading:false });
        Swal.fire({
            title: `<strong>Failed}</strong>`,
            text: "Opps...! Something went wrong.",
            icon: "error",
            showConfirmButton: true,
            allowOutsideClick: false,
        });
      });
  };

  handleInputSearch = (e) => {
      this.GetList();
  };
  handleClearAll = () => {
    this.setState(
      {
        grade_id: "",
        designation_id: "",
        location_id: "",
        department_id: "",
        category_id: "",
        location_shift_id: "",
        attendance_capture_mode: "All",
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
        assigned_attendance_status:"All",
      },
      () => {
        this.GetList();
      }
    );
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },
    () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };

  handleMultiSelect = (fieldName, selectedOptions) => {
    if (selectedOptions.some(option => option.value === "All")) {
        // Get all options except "All"
        const ids = this.state.DataCaptures
            ? this.state.DataCaptures
                  .filter(option => option.value !== "All")
                  .map(option => option.value)
            : [];
        console.log(ids.join(','));
        this.setState({ [fieldName]: ids.join(',') },()=> console.log("attendance_capture_mode 1",this.state.attendance_capture_mode));
    } else {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({ [fieldName]: ids.join(',') },()=> console.log("attendance_capture_mode 2",this.state.attendance_capture_mode));
    }
};


handleCheckboxChange = (employeeData) => {
    // console.log("employeeData",employeeData);
    const { selectedRows } = this.state;
    const isSelected = selectedRows.some(row => row.employee_id === employeeData?.employee_id);

    if (isSelected) {
        this.setState({
            selectedRows: selectedRows.filter(row => row.employee_id !== employeeData?.employee_id),
        });
    } else {
        this.setState({
            selectedRows: [
                ...selectedRows,
                {
                    employee_id: employeeData?.employee_id,
                    employee_name: employeeData?.employee_name,
                    employee_code: employeeData?.employee_code,
                },
            ],
        });
    }
};
  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) =>{
          return { employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code }
        });

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === "select-all") {
      this.setState({
        selectedRows: this.state.rows.map((row) => row.employee_id),
      });
    } else if (action === "deselect-all") {
      this.setState({ selectedRows: [] });
    }
  };

  GetShiftList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetShiftList `, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Shift_rows: data.data.map((row) => ({
              value: row.company_location_shift_id,
              label: row.company_location_shift_name,
            })),
          }));
        }
      });
  };

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.department;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          department_options: data.map((row) => ({
            value: row.department_id,
            label: row.department_title,
          })),
        }));
      }
    });
  };
  GetLeavesMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Attendance/GetAssignedCaptureMode`, 
        { params: { 
            limit: 999, 
            page: 1 
        }, headers })
    .then((response) => {
      const data = response.data.data;
      if (response.data.success === true) {
        console.log("GetAssignedCaptureMode===>",data);
        const temp = data.map((row) => ({
            value: row.attedance_capture_mode,
            label: row.attendance_capture_mode_name,
          }));
        temp.unshift({value:'All', label:"All"});
        console.log("temp",temp);
        this.setState((prevState) => ({
          capturemode_options: temp,
        }));
      }
    });
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            location_options: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetEmploymentMasterList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
      .then((response) => {
        let data = response.data;
        if (response.data.success === true) {
            data= data?.data;
          this.setState((prevState) => ({
            location_options: data.location_list.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
            department_options: data?.department_list.map((row) => ({
                value: row.department_id,
                label: row.department_title,
              })),
            designation_options: data?.designation_list.map((row) => ({
                value: row.designation_id,
                label: row.designation_title,
              })),
            grade_options: data?.grade_list.map((row) => ({
                value: row.grade_id,
                label: row.grade_title,
              })),
            state_options: data?.state_list.map((row) => ({
                value: row.state_id,
                label: row.state_title,
              })),
            category_options: data?.category_list.map((row) => ({
                value: row.company_employee_category_id,
                label: row.company_employee_category,
              })),
            type_options: data?.type_list.map((row) => ({
                value: row.company_employee_type_id,
                label: row.company_employee_type,
              })),
          }));  
        }
      });
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetShiftList();
        this.GetLocationList();
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };


  render() {
    const {DataCaptures} = this.state;
    const limitOptions = [10, 25, 50, 100, 200, 500, ];
    const assignedStatusOptions=[
        {value:"All", label:"All"},
        {value:"1", label:"Assigned"},
        {value:"2", label:"UnAssigned"},
        
    ];

    return (
      
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Send Bulk Letters`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="keyword">Employee Name/Code</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange}
                            name="keyword" value={this.state.keyword} aria-label="Recipient's username"
                            aria-describedby="button-addon2" placeholder="Search Here..."
                          />
                          <button
                            className="btn btn-success"
                            // disabled={this.state.loadingSearch}
                            onClick={() => {
                              if (
                                this.state.keyword &&
                                !this.state.loadingSearch
                              ) {
                                this.handleInputSearch();
                              }
                            }}
                            type="button"
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px",}}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                        <div className="col-md-3 position-relative">
                            <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Grade</label>
                                </div>
                                <Select
                                options={this.state.grade_options}
                                value={ this.state.grade_id ? this.state.grade_options.find(
                                        (option) => option.value === this.state.grade_id) : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "grade_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Grade`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 position-relative">
                            <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Designation</label>
                                </div>
                                <Select
                                options={this.state.designation_options}
                                value={
                                    this.state.designation_id
                                    ? this.state.designation_options.find(
                                        (option) =>
                                            option.value === this.state.designation_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "designation_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Designation`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Location</label>
                                </div>
                                <Select
                                options={this.state.location_options}
                                value={
                                    this.state.location_id
                                    ? this.state.location_options.find(
                                        (option) =>
                                            option.value === this.state.location_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "location_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Location`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 7, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Department</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "department_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Department`}
                                options={this.state.department_options}
                                value={
                                    this.state.department_id
                                    ? this.state.department_options.find(
                                        (option) =>
                                            option.value === this.state.department_id
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 6, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Category</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "category_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Category`}
                                options={this.state.category_options}
                                value={
                                    this.state.department_id
                                    ? this.state.category_options.find(
                                        (option) =>
                                            option.value === this.state.category_id
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <div className="row">
                                <div className="col-md-6">
                                <div>
                                    <label>Apply Filter</label>
                                </div>
                                    <SubmitButton
                                    onClick={()=>{
                                        if(!this.state.loadingFilter){
                                            this.setState({loadingFilter: "1"},
                                            () => { this.handleInputSearch()})
                                        }
                                    }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_attendance_status || this.state.assigned_attendance_status==="All")}
                                    loading={this.state.loadingFilter==="1"}
                                    loadingMessage='loading' buttonName={"Filter"} icon={'ri-filter-3-fill'} 
                                    type='info' iconSide='left' />
                                </div>
                                <div className="col-md-6">
                                    <div>
                                        <label>Clear Filter</label>
                                    </div>
                                    <SubmitButton
                                        onClick={()=>{
                                    if(!this.state.loadingFilter){
                                        this.setState({loadingFilter: "2"},
                                        () => { this.handleClearAll()})
                                    }
                                    }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_attendance_status || this.state.assigned_attendance_status==="All")}
                                    loading={this.state.loadingFilter==="2"}
                                    loadingMessage='loading' buttonName={"Clear"} icon={'ri-database-2-line'} 
                                    type='secondary' iconSide='left' />
                                </div>
                            </div>
                        </div>
                    
                        { this.state.decodedData?.includes(3) && (
                        <div className='col-md-3 '>
                            <div>
                            <label>Send Letter</label>
                            </div>
                            <button
                            onClick={()=> this.setState({assignedModal:true})}
                            type="button"
                            className={`btn btn-success btn-label waves-effect waves-light 
                            ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}`}>
                            <i className="ri-user-settings-line label-icon align-middle fs-16" />
                            Send
                            </button>
                        </div>)}
                    </div>
                  </div>
                  <div className="card-body">
                  <div className="row">
                    <div style={{ maxHeight: '65vh', overflowY: 'auto' }} className="col-sm-12">
                        <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative"
                            style={{ minWidth: '100%' }}>
                        <thead  className="bg-primary text-light bg-gradient  sticky-top z-1">
                            <tr>
                            {this.state.rows.length>0 && this.state.decodedData?.includes(3) && (
                            <th>
                                <div className="d-flex gap-1 align-items-center justify-content-center">
                                    <input type="checkbox" className="form-check-input cursorPointer" 
                                    checked={this.state.selectedRows.length === this.state.rows.length && this.state.rows.length>0}
                                    onChange={this.handleSelectAll}
                                    />
                                    Select{" "}
                                    {this.state.selectedRows?.length > 0 && ( <span className="text-white">({this.state.selectedRows?.length})
                                    </span>
                                    )}
                                </div>
                            </th>)}
                            <th>Employee Code</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>Official Email</th>
                            </tr>
                        </thead>
                        {this.state.rows.length === 0 ? (
                            <tbody>
                            <tr>
                                <td colSpan={11}>
                                <NoRecords />
                                </td>
                            </tr>
                            </tbody>
                        ) : (
                            <tbody>
                            {this.state.rows.map((row) => {
                                return (
                                <tr key={row.employee_id}>
                                    { this.state.decodedData?.includes(3) && (
                                    <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={this.state.selectedRows.some(val => val.employee_id == row?.employee_id)}
                                        onChange={() => this.handleCheckboxChange(row)}
                                        />
                                    </div>
                                    </td>)}
                                    <td>{row.employee_code}</td>
                                    <td>{row.employee_name}</td>
                                    <td>{row.designation_title}</td>
                                    <td>{row.employee_email_address}</td>
                                </tr>
                                );
                            })}
                            </tbody>
                        )}
                        </table>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2">
                        <button
                        disabled={
                            this.state.prev === false &&
                            this.state.loadingList === false
                            ? true
                            : false
                        }
                        type="button"
                        onClick={() => this.handlePrev()}
                        className={`btn btn-warning btn-label waves-effect waves-light`}
                        >
                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                        Previous
                        </button>
                        <div
                        className="col-md-4"
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                        >
                        {
                            <small>
                            Total Records: {this.state.total_records} |
                            Total Pages: {this.state.total_pages} |
                            Current Page: {this.state.page}
                            </small>
                        }
                        </div>
                        <div className="col-md-2">
                        <select
                            className="form-select"
                            onChange={(e) => this.handleChange(e)}
                        >
                            {Array.from(
                            { length: this.state.total_pages },
                            (_, i) => (
                                <option
                                selected={this.state.page === i + 1}
                                key={i}
                                value={i + 1}
                                >
                                Page {i + 1}
                                </option>
                            )
                            )}
                        </select>
                        </div>
                        <div className="col-md-2">
                        <select
                            className="form-select"
                            onChange={this.handleLimitChange}
                            value={this.state.limit}
                        >
                            <option value={this.state.total_records}>
                                All
                            </option>
                            {limitOptions.map((option) => (
                                <option key={option} value={option}>
                                Limit {option}
                                </option>
                            ))}
                        </select>
                        </div>
                        <button
                        disabled={
                            this.state.next === false &&
                            this.state.loadingList === false
                            ? true
                            : false
                        }
                        type="button"
                        onClick={() => this.handleNext()}
                        className={`btn btn-primary btn-label waves-effect right waves-light`}
                        >
                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                        Next
                        </button>
                    </div>
                    </div>
                    {this.state.assignedModal && (
                        <div className="modal show" tabIndex={-1}
                            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                            aria-labelledby="myModalLabel"
                            aria-hidden="true">
                        <div className=" bg-light m-auto mt-3"
                                style={{ width: "40%" }}>
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Send Letter</h5>
                                <button
                                type="button"
                                disabled={this.state.postLoading}
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({
                                            assignedModal:false, 
                                            selectedEmail:false,
                                            selectedLetter:false,
                                            shareCtc:false,
                                            shareSalary:false,
                                            mail_subject: "", 
                                            company_letter_content: "", 
                                            company_letter_title: "", 
                                            markings: "", 
                                            letterhead_url: "", 
                                            selectedSignatoryTemplate: "", 
                                            mail_body: "", 
                                            selectedRows:[]});
                                    }
                                }}
                                className="btn-close"
                                aria-label="Close"
                                />
                            </div>
                            <div className="modal-body py-0">
                                <form>
                                    <div className="mb-3">
                                        <label>Select Email</label>
                                        <Select 
                                        onChange={(selectedOptions) =>  this.setState({ selectedEmail: selectedOptions?.value, mail_body: selectedOptions?.mail_body, mail_subject: selectedOptions?.mail_subject })}
                                        placeholder={"Search/Select Email"}                            
                                        options={this.state.emailOptions}
                                        value={this.state.selectedEmail ? this.state.emailOptions.find(option => option.value == this.state.selectedEmail) : null}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Select Letter</label>
                                        <Select 
                                        onChange={(selectedOptions) =>  this.setState({ selectedLetter: selectedOptions?.value, 
                                            company_letter_content: selectedOptions?.company_letter_content,
                                            company_letter_title: selectedOptions?.label,
                                            markings: selectedOptions?.markings,
                                            letterhead_url: selectedOptions?.letterhead_url,
                                         })}
                                        placeholder={"Search/Select Letter"}                            
                                        options={this.state.lettersOptions}
                                        value={this.state.selectedLetter ? this.state.lettersOptions.find(option => option.value == this.state.selectedLetter) : null}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                        <label>Signatory</label>
                                        <Select
                                            id='Signatory'
                                            name='Signatory'
                                            value={this.state.signatoryRows.find(
                                            option =>
                                                option.value == this.state.selectedSignatoryTemplate
                                            )}
                                            onChange={(selectedOptions) =>  this.setState({ selectedSignatoryTemplate: selectedOptions?.value,})}
                                            options={this.state.signatoryRows}
                                        />
                                    </div>
                                    <div className='mb-3'>
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        value=''
                                        id='auth-remember-check1'
                                        checked={this.state.shareCtc}
                                        onChange={(event)=> this.setState({ shareCtc: event.target.checked })}
                                    />
                                    <label
                                        className='form-check-label ms-2'
                                        htmlFor='auth-remember-check1'
                                    >
                                        Do You Want to Share CTC structure
                                    </label>
                                    </div>
                                    <div className='mb-3'>
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        value=''
                                        id='auth-remember-check2'
                                        checked={this.state.shareSalary}
                                        onChange={(event)=> this.setState({ shareSalary: event.target.checked })}
                                    />
                                    <label
                                        className='form-check-label ms-2'
                                        htmlFor='auth-remember-check2'
                                    >
                                        Do You Want to Share CTC amount
                                    </label>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                type="button"
                                className="btn btn-light"
                                disabled={this.state.postLoading}
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({assignedModal:false, 
                                            selectedEmail:false,
                                            selectedLetter:false,
                                            shareCtc:false,
                                            shareSalary:false,
                                            mail_subject: "", 
                                            company_letter_content: "", 
                                            company_letter_title: "", 
                                            markings: "", 
                                            letterhead_url: "", 
                                            selectedSignatoryTemplate: "", 
                                            mail_body: "", 
                                            selectedRows:[]});
                                    }
                                }}
                                >
                                Close
                                </button>
                                <SubmitButton
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({postLoading:true},()=>this.handleSubmit())
                                    }
                                }}
                                disabled={!this.state.selectedEmail || !this.state.selectedLetter || !this.state.selectedSignatoryTemplate}
                                loading={this.state.postLoading}
                                loadingMessage='loading' buttonName={"Send"} icon={'ri-save-line'} 
                                type='primary' iconSide='left' />
                            </div>
                            </div>
                        </div>
                        </div>
                    )}
                    {this.state.responseModal && (
                    <div id="myModal" className="modal show" tabIndex={-1} style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                    >
                        <div
                        className=" bg-light m-auto mt-3"
                        style={{ width: "60%" }}
                        >
                        <div className="modal-content">
                            <div
                            style={{ padding: "10px 10px 0 10px" }}
                            className="modal-header"
                            >
                                <h5 className="modal-title" id="myModalLabel">
                                    Response List 
                                </h5>
                                <button
                                    onClick={() => {
                                        if(!this.state.loadingPost){
                                            this.setState({ responseModal:false, responseList:[], })
                                        }
                                    }}
                                    className="btn-close"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div
                                    style={{ padding: "10px 0px 0 0px" }}
                                    className=" form-steps"
                                >
                                <div className="card-body row gy-4">
                                    <div className="col-md-12">
                                    <div style={{ "maxHeight": "75vh", "overflowY": "auto", "overflowX": "auto" }}>
                                        <table style={{ minwidth: '100%' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                                          <thead className='bg-primary text-light bg-gradient position-sticky top-0 z-1'>
                                            <tr>
                                              <th>Sr.No.</th>
                                              <th>Employee Code</th>
                                              <th>Employee Name</th>
                                              <th>Response</th>
                                            </tr>
                                          </thead>
                                            <tbody>
                                              {Array.isArray(this.state.responseList) && this.state.responseList?.map((row,idx) => {
                                                return (
                                                  <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{row?.employee_code}</td>
                                                    <td>{row?.employee_name}</td>
                                                    <td className={` text-left fw-bolder text-danger`}>{row?.error_message}</td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                  )}
                    {this.state.assignedAttendanceCaptureMode && (
                        <div className="modal show" tabIndex={-1}
                            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                            aria-labelledby="myModalLabel"
                            aria-hidden="true">
                        <div className=" bg-light m-auto mt-3"
                                style={{ width: "40%" }}>
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assigned Capture Mode</h5>
                                <button
                                type="button"
                                disabled={this.state.postLoading}
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({assignedAttendanceCaptureMode:false, selectedRows:[]});
                                    }
                                }}
                                className="btn-close"
                                aria-label="Close"
                                />
                            </div>
                            <div className="modal-body py-0">
                                <form>
                                <div className="mb-3">
                                    <label>Attendance Capture Mode</label>
                                    <Select
                                    ref={this.sourceDiv1Ref}
                                    // onChange={(selectedOptions) => this.handleMultiSelect("leave_type_ids", selectedOptions)}
                                    placeholder={"Select Mode"}
                                    isMulti
                                    isDisabled
                                    options={DataCaptures}
                                    value={this.state.assignedAttendanceCaptureMode ? this.state.assignedAttendanceCaptureMode?.split(',').map(id => DataCaptures.find(option => option.value == id)) : null}
                                    // value={typeof this.state.capturemode_options === "string"
                                    //   ? this.state.capturemode_options.split(',').map(id => DataCaptures.find(option => option.value === id))
                                    //   : Array.isArray(this.state.capturemode_options)
                                    //   ? this.state.capturemode_options.map(id => DataCaptures.find(option => option.value === id))
                                    //   : null}
                                />
                                </div>
                                </form>
                            </div>
                            </div>
                        </div>
                        </div>
                    )}
                
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    );
  }
}
export default withRouter(SendBulkLetters);
